import React from 'react';
import { Compass, Heart, Layers, ShieldCheck } from 'lucide-react';

const values = [
  {
    icon: Compass,
    title: 'Outcome > Output',
    body: 'We measure success in revenue per subscriber and replies, not in emails sent.',
  },
  {
    icon: Layers,
    title: 'Systems thinking',
    body: 'Every campaign plugs into a flow that compounds — not a one-off blast.',
  },
  {
    icon: ShieldCheck,
    title: 'Deliverability first',
    body: 'If it doesn’t hit inboxes, the rest is theatre. We obsess over the boring stuff.',
  },
  {
    icon: Heart,
    title: 'Long-term partnerships',
    body: '70% of clients stay over a year. The work compounds when we stick around.',
  },
];

const CoreValues = () => {
  return (
    <section className="container-x section" data-testid="core-values">
      <div className="grid lg:grid-cols-12 gap-10 items-end">
        <div className="lg:col-span-5">
          <p className="text-xs uppercase tracking-[0.25em] text-[var(--gh-orange)] font-semibold">
            Core values
          </p>
          <h2 className="font-display text-4xl md:text-5xl font-extrabold mt-3 leading-[1.05] text-ink">
            How we think about the inbox.
          </h2>
        </div>
        <p className="lg:col-span-7 text-muted-warm text-base md:text-lg">
          Email isn&apos;t a channel — it&apos;s a relationship layer. Every decision we make on
          behalf of a client funnels back to four principles we don&apos;t budge on.
        </p>
      </div>

      <div className="mt-12 grid md:grid-cols-2 lg:grid-cols-4 gap-5">
        {values.map((v, i) => (
          <div
            key={v.title}
            data-testid={`core-value-${i + 1}`}
            className="card-cream p-7 group"
          >
            <div className="flex items-center justify-between">
              <span className="w-11 h-11 rounded-2xl bg-[var(--gh-orange-soft)] text-[var(--gh-orange)] flex items-center justify-center group-hover:bg-[var(--gh-orange)] group-hover:text-white transition-colors">
                <v.icon className="w-5 h-5" />
              </span>
              <span className="idx-dot">0{i + 1}</span>
            </div>
            <h3 className="font-display text-xl font-bold mt-6 text-ink">{v.title}</h3>
            <p className="mt-3 text-sm text-muted-warm leading-relaxed">{v.body}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default CoreValues;
